import React, {useState} from 'react';
import {FormattedMessage} from 'react-intl';
import {useHistory} from 'react-router-dom';
import classNames from 'classnames';
import TableUnpaidLines from './TableUnpaidLines';
import TableSplitLines from './TableSplitLines';
import TableHiddenLines from './TableHiddenLines';
import PopupSetOwnership from './PopupSetOwnership';
import PopupRestoreOwnership from './PopupRestoreOwnership';
import PopupCreateTransfer from './PopupCreateTransfer';
import {useBulkActionsContext} from '../contexts/BulkActionsContext';
import {PopupCreateTransferContextProvider} from '../contexts/PopupCreateTransferContext';
import {useTransfersByAgentContext} from '../contexts/TransfersByAgentContext';
import {TransferCalculationContextProvider} from '../contexts/TransferCalculationContext';
import styles from './styles.module.scss';

export function BulkActions() {
  const [showHiddenLines, setShowHiddenLines] = useState(false);
  const {hasSelectedLines, handleSetHidden, handleSetShowed} = useBulkActionsContext();
  const history = useHistory();
  const {userId} = useTransfersByAgentContext();
  const goToUserPage = () => history.push(`/user/${userId}`);
  const prefix = 'transfersByAgent-bulk-actions';

  return (
    <div>
      <div className={styles.tabs}>
        <TransferCalculationContextProvider>
          <PopupCreateTransferContextProvider>
            <PopupCreateTransfer/>
          </PopupCreateTransferContextProvider>
        </TransferCalculationContextProvider>
        <button className={classNames(showHiddenLines ? styles.primary : styles.secondary, 'w-150px')}
                onClick={() => setShowHiddenLines((prevState) => !prevState)}
        >
          {showHiddenLines
            ? <FormattedMessage id={`${prefix}-hide-hidden`} defaultMessage={'Hide hidden lines'}/>
            : <FormattedMessage id={`${prefix}-show-hidden`} defaultMessage={'Show hidden lines'}/>
          }
        </button>
        <button className={styles.secondary} onClick={() => handleSetShowed()} disabled={!hasSelectedLines}>
          <FormattedMessage id={`${prefix}-show-selection`} defaultMessage={'Show selection'}/>
        </button>
        <button className={styles.secondary} onClick={() => handleSetHidden()} disabled={!hasSelectedLines}>
          <FormattedMessage id={`${prefix}-hide-selection`} defaultMessage={'Hide selection'}/>
        </button>
        <PopupSetOwnership disabled={!hasSelectedLines}/>
        <PopupRestoreOwnership disabled={!hasSelectedLines}/>
        <button
          className={classNames(styles.primary, 'ml-auto')}
          onClick={() => goToUserPage()}
          disabled={!userId}
        >
          <FormattedMessage id={`transfersByAgent-go-to-user-page`} defaultMessage="Go to user page"/>
        </button>
      </div>
      <div className={styles.card}><TableUnpaidLines/></div>
      {showHiddenLines && <div className={styles.card}><TableHiddenLines/></div>}
      {showHiddenLines && <div className={styles.card}><TableSplitLines/></div>}
    </div>
  );
}
